import { render, staticRenderFns } from "./activeColor-editor.vue?vue&type=template&id=6f769ed0&scoped=true"
import script from "./activeColor-editor.vue?vue&type=script&lang=js"
export * from "./activeColor-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f769ed0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f769ed0')) {
      api.createRecord('6f769ed0', component.options)
    } else {
      api.reload('6f769ed0', component.options)
    }
    module.hot.accept("./activeColor-editor.vue?vue&type=template&id=6f769ed0&scoped=true", function () {
      api.rerender('6f769ed0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/field-switch/activeColor-editor.vue"
export default component.exports